/**
 * Created by lk on 17/6/4.
 */
import axios from "../../utils/axios";

// Get list
export function authAdminList(query) {
    return axios({
        url: "/admin/auth/user/index",
        method: "get",
        params: query
    });
}

// Get role list
export function authAdminRoleList(query) {
    return axios({
        url: "/admin/auth/user/roleList",
        method: "get",
        params: query
    });
}

// save
export function authAdminSave(data, formName, method = "post") {
    let url = formName === "Add" ?
        "/admin/auth/user/save" :
        "/admin/auth/user/edit";
    return axios({
        url: url,
        method: method,
        data: data
    });
}

// Delete administrator
export function authAdminDelete(data) {
    return axios({
        url: "/admin/auth/user/delete",
        method: "post",
        data: data
    });
}
// save
export function authAdminSaveResetPassword(data, formName, method = "post") {
    let url = "/admin/auth/user/resetPassword";
    return axios({
        url: url,
        method: method,
        data: data
    });
}
